__turbopack_context__.v({
  "banner": "SimulatorHub-module__umon2W__banner",
  "hero": "SimulatorHub-module__umon2W__hero",
  "hub": "SimulatorHub-module__umon2W__hub",
  "pager": "SimulatorHub-module__umon2W__pager",
  "ranking": "SimulatorHub-module__umon2W__ranking",
});
